import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import translations
import enTranslation from "./locales/en/translation.json";
import koTranslation from "./locales/ko/translation.json";
import jpTranslation from "./locales/jp/translation.json";
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({

    resources: {
      en: {
        translation: enTranslation,
      },
      kr: {
        translation: koTranslation,
      },
      jp: {
        translation: jpTranslation,
      },
    },
    lng: "jp",
    fallbackLng: "jp",
    debug: true,

    //
    ns: ["translation"],
    defaultNS: "translation",

    keySeparator: ".",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
